import { useState } from 'react';
import { Field } from 'formik';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const AzureRegionsField = ({ darkMode, errors, touched, regionsEnum }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 0 24px 0 !important', width: '100%' }}
            isInvalid={!!(errors?.regions && touched?.regions)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                alignItems="flex-start"
                sx={stackStyling(true)}
                width="100%">
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Regions <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select one or more regions for this ACS service.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px" height="auto">
                    <Field
                        name="regions"
                        validate={(value) => {
                            if (!value || value.length === 0) {
                                return 'Please select at least one region.';
                            }
                            return undefined;
                        }}>
                        {({ field, form }) => (
                            <DropDown
                                data={regionsEnum}
                                shownValue="name"
                                isMulti
                                multiValue={
                                    Array.isArray(field.value)
                                        ? field.value.map((r) => r.id)
                                        : []
                                }
                                placeholder="- Select Regions -"
                                darkMode={darkMode}
                                width="100%"
                                handleSelectChange={(ids) => {
                                    const selected = (ids || [])
                                        .map((id) =>
                                            (regionsEnum || []).find(
                                                (r) => r.id === id,
                                            ),
                                        )
                                        .filter(Boolean);
                                    form.setFieldValue('regions', selected);
                                }}
                            />
                        )}
                    </Field>
                    {errors?.regions && touched?.regions && (
                        <Text
                            color="red.500"
                            fontSize="xs"
                            mt={1}
                            textAlign="right">
                            {errors.regions}
                        </Text>
                    )}
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select one or more regions for this ACS service."
                        ariaLabel="azure-regions-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default AzureRegionsField;
